import { SearchRoute } from 'api/search';
import { SearchFiltersRoute } from 'api/search/filters';
import { SearchWithFiltersRoute } from 'api/search/with-filters';
import ApiRoute from 'utils/apiRoute';

export const searchRoute: SearchRoute = new ApiRoute('/search', 'POST');
export const searchFiltersRoute: SearchFiltersRoute = new ApiRoute('/search/filters', 'POST');
export const searchWithFiltersRoute: SearchWithFiltersRoute = new ApiRoute('/search/with-filters', 'POST');
